$(document).ready(function () {
    //IMAGE TEXT CARD CAROUSEL SCRIPT START
    $('.image-text-card-carousel .owl-carousel').owlCarousel({
        loop: ($('.owl-carousel .items').length > 4),
        //loop: true,
        margin: 20,
        //nav: ($('.owl-carousel .items').length > 4),
        nav: true,
        autoplay: false,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
            1200: { items: 4 }
        }
    });
    //IMAGE TEXT CARD CAROUSEL SCRIPT END

    //HIGHLIGHTS CAROUSEL SCRIPT START
    $('.highlights-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: false,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 },
            1200: { items: 1 }
        }
    });
    //HIGHLIGHTS CAROUSEL SCRIPT END

    //SIDEBAR CAROUSEL SCRIPT START
    $('.sidebar-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: false,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 }
        }
    });
    //SIDEBAR CAROUSEL SCRIPT END

    //EVENT CAROUSEL SCRIPT START
    $('.event-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: false,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 }
        }
    });
    //EVENT CAROUSEL SCRIPT END

    //PARTNERS CAROUSEL SCRIPT START
    $('.partners-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 3 },
            960: { items: 5 },
            1200: { items: 6 }
        }
    });
    //PARTNERS CAROUSEL SCRIPT END

    //SIDEBAR OVERLAY TEXT CAROUSEL SCRIPT START
    $('.sidebar-overlay-text-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        autoplay: false,
        navText: ["", ""],
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 }
        }
    });
    //SIDEBAR OVERLAY TEXT CAROUSEL SCRIPT END
    //TESTIMONIALS TEXT CARD CAROUSEL SCRIPT START
    $('.testimonials-text-card-carousel .owl-carousel').owlCarousel({
        loop: ($('.owl-carousel .items').length > 3),
        margin: 20,
        nav: true,
        autoplay: false,
        navText: ["", ""],
        dots: false,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
            1200: { items: 3 }
        }
    });
    //TESTIMONIALS TEXT CARD CAROUSEL SCRIPT END
});
